export default __webpack_public_path__ + "static/media/ShiftsCompleted.e4dd344b.svg";